import React, { useRef, useEffect, useCallback } from 'react'
import moment from 'moment'
import Chart from './config'
import { StyledChartContainer, StyledChartWrapper, StyledChart, StyledChartTable, StyledChartTableHeader, StyledChartTableBody, StyledChartTableBodyItem } from './styled'
import { pathOr, isEmpty, isNil } from 'ramda'

const MyChart = ({ config }) => {
    let chartRef = useRef()
    let chartTabeleRef = useRef()
    const chartObjectRef = useRef(null)

    const getOptions = useCallback(() => {
        const defaultOptions = {
            onResize: function (chart, size) {
                if(chartTabeleRef.current) {
                    chartTabeleRef.current.style.top = `${((chart.chartArea.top * 100) / size.height) + 0.25}%`;
                    chartTabeleRef.current.style.left = `${((chart.chartArea.left * 100) / size.width) + 0.25}%`;
                }
            },
            // onHover: function (point, event) { //Set dynamically mode on hover
            //     if (event[0]) {
            //         const datasets = pathOr(null, ['_chart', 'config', 'data', 'datasets'], event[0]);
            //         const datasetIndex = pathOr(null, ['_datasetIndex'], event[0]);
            //         if (datasets !== null && datasetIndex !== null) {
            //             const mode = pathOr(null, ['tooltip', 'mode'], datasets[datasetIndex]);
            //             if (mode !== null && chartObjectRef.current) {
            //                 const currentMode = pathOr(null, ['current', 'options', 'tooltips', 'mode'], chartObjectRef);
            //                 if (currentMode !== mode) {
            //                     chartObjectRef.current.options.tooltips.mode = mode;
            //                     chartObjectRef.current.update();
            //                 }
            //             }
            //         }
            //     }
            // },
        }
        if (config) {
            return {
                ...config.options,
                ...defaultOptions
            };
        } else {
            return defaultOptions;
        }
    }, [config])

    const getData = useCallback(() => {
        const parseItemToTime = item => {
            return {
                ...item,
                data: item.data ? item.data.map(i => ({ ...i, x: moment.unix(i.x)._d })) : []
            }
        }
        return config && config.data.datasets.map(item => {
            const xAxisID = pathOr('', ['xAxisID'], item);
            if (isEmpty(xAxisID)) {
                return parseItemToTime(item);
            } else {
                const xAxes = pathOr([], ['options', 'scales', 'xAxes'], config);
                const xAxesItem = xAxes.find(x => x.id === xAxisID);
                if (isNil(xAxesItem) || (isNil(xAxesItem.type) || xAxesItem.type === 'time')) {
                    return parseItemToTime(item);
                } else {
                    return item;
                }
            }
        })
    }, [config])

    const generateTable = () => {
        const table = pathOr(null, ['data', 'table'], config);
        if (chartObjectRef.current && table === null) {
            return
        }
        return (
            <StyledChartTable
                ref={chartTabeleRef}
                top={`${((chartObjectRef.current.chartArea.top * 100) / chartObjectRef.current.height) + 0.25}%`}
                left={`${((chartObjectRef.current.chartArea.left * 100) / chartObjectRef.current.width) + 0.25}%`}
            >
                {
                    table.header &&
                    <StyledChartTableHeader>
                        {table.header}
                    </StyledChartTableHeader>
                }
                {
                    table.body &&
                    <StyledChartTableBody>
                        {table.body.map((item, index) => (
                            <StyledChartTableBodyItem
                                key={index}
                            >
                                {item.text}
                            </StyledChartTableBodyItem>
                        ))}
                    </StyledChartTableBody>
                }
            </StyledChartTable>
        )
    }

    useEffect(() => {
        const myChartRef = chartRef.current.getContext("2d")
        chartObjectRef.current = new Chart(myChartRef, {
            options: getOptions(),
            data: {
                datasets: getData()
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        if (chartObjectRef.current && config) {
            chartObjectRef.current.options = getOptions();
            chartObjectRef.current.data.datasets = getData();
            chartObjectRef.current.update();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config])

    return (
        <StyledChartContainer>
            <StyledChartWrapper>
                <StyledChart
                    ref={chartRef}
                />
                {
                    chartObjectRef.current && generateTable()
                }
            </StyledChartWrapper>
            {
                chartObjectRef.current && chartObjectRef.current.generateLegend()
            }
        </StyledChartContainer>
    )
}

export default MyChart